import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { store } from './utils/store.js';
import { channelCode } from '@/js/channel';
import { X } from './utils/request.js';
export default {
  __name: 'App',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const activeChannel = computed(() => {
      const raw = store.config && store.config.channelCode || X.Xchanne || channelCode || '';
      return String(raw).toUpperCase();
    });
    const showCustomerServiceButton = computed(() => activeChannel.value !== 'MANF' && activeChannel.value !== 'haijiao-17' && route.path !== '/customer-service');
    const goCustomerService = () => {
      router.push('/customer-service');
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_back_top = _resolveComponent("van-back-top");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        theme: "dark"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view), _createVNode(_component_van_back_top, {
          right: "5vw",
          bottom: "15vh"
        }), showCustomerServiceButton.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "customer-service-button",
          type: "button",
          onClick: goCustomerService
        }, [_createVNode(_component_van_icon, {
          name: "service",
          size: "1.2rem"
        })])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};